import { publishPayload } from './PublishStore';

export const updatePublishPayload = (value) => publishPayload.update((oldValue) => value);
